/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Off_ButtonInputs */

const es_chat_branch_off_button = /** @type {(inputs: Chat_Branch_Off_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bifurcar conversación`)
};

const en_chat_branch_off_button = /** @type {(inputs: Chat_Branch_Off_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch off conversation`)
};

/**
* | output |
* | --- |
* | "Branch off conversation" |
*
* @param {Chat_Branch_Off_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_branch_off_button = /** @type {((inputs?: Chat_Branch_Off_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Off_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_branch_off_button(inputs)
	return en_chat_branch_off_button(inputs)
});
export { chat_branch_off_button as "chat.branch_off.button" }